import { supabase, supabaseAdmin } from '../lib/supabase';
import { logAction, getCurrentAdmin } from './logger';

export type AppConfigValueType = 'number' | 'boolean' | 'string';
export type AppConfigSection = 'validation' | 'performance' | 'bar_interface';

export interface AppConfigRow {
  key: string;
  value: number | boolean | string;
  value_type: AppConfigValueType;
  section: AppConfigSection;
  label: string;
  description: string | null;
  updated_at: string;
  updated_by: string | null;
}

export const SECTION_META: Record<AppConfigSection, { title: string; subtitle: string }> = {
  validation: {
    title: 'Validation communautaire',
    subtitle: 'Seuils et points pour les votes ONpitchers (Ça diffuse / Ça diffuse pas).',
  },
  performance: {
    title: 'Performances',
    subtitle: 'Cache et latence côté app mobile.',
  },
  bar_interface: {
    title: 'Interface bar',
    subtitle: 'Feature flags pour la future interface dédiée aux propriétaires de bar.',
  },
};

export const SECTION_ORDER: AppConfigSection[] = ['validation', 'performance', 'bar_interface'];

export async function listAppConfig(): Promise<AppConfigRow[]> {
  const { data, error } = await supabase
    .from('app_config')
    .select('*')
    .order('section')
    .order('key');
  if (error) throw error;
  return (data || []).map(parseRow);
}

export async function updateAppConfig(
  key: string,
  oldValue: number | boolean | string,
  newValue: number | boolean | string,
  label: string
): Promise<void> {
  const admin = getCurrentAdmin();
  const { error } = await supabaseAdmin
    .from('app_config')
    .update({
      value: newValue,
      updated_at: new Date().toISOString(),
      updated_by: admin?.email || 'unknown',
    })
    .eq('key', key);
  if (error) throw error;
  await logAction(
    'update_app_config',
    'app_config',
    key,
    { value: oldValue },
    { value: newValue },
    `${admin?.name || 'admin'} a modifié "${label}" : ${formatValue(oldValue)} → ${formatValue(newValue)}`
  );
}

function parseRow(raw: any): AppConfigRow {
  return {
    key: raw.key,
    value: raw.value,
    value_type: raw.value_type,
    section: raw.section,
    label: raw.label,
    description: raw.description,
    updated_at: raw.updated_at,
    updated_by: raw.updated_by,
  };
}

function formatValue(v: number | boolean | string): string {
  if (typeof v === 'boolean') return v ? 'activé' : 'désactivé';
  return String(v);
}
